import axios from "axios";
import Cookies from "js-cookie";
import {Stream2Plugin} from "./stream2-plugin";
import {CountDownTimer} from "./countdown-timer";

const Stream2Player = {};
(function(o) {

    o.hasAccess = false;
    o.showModal = false;

    o.whenAvailable = function(name, callback) {
        let interval = 10;
        window.setTimeout(function() {
            if (window[name]) {
                callback(window[name]);
            } else {
                o.whenAvailable(name, callback);
            }
        }, interval);
    }

    o.initialize = function () {

        o.whenAvailable("stream2Player", function (t) {
            o.eventListeners();
            o.debugListeners();
        });

        $(document).ready(function() {
            $(document).on('brightcoveVideoPlayerLoaded', function() {
                o.eventListeners();
                o.debugListeners();
            });
        });
    }

    o.currentVideoId = function () {
        if(window.stream2Player.mediainfo !== undefined && window.stream2Player.mediainfo.id) {
            return window.stream2Player.mediainfo.id;
        }
        return null;
    }

    o.play = function () {
        window.stream2Player.play();
        if(!window.stream2Player.hasClass('vjs-has-started')) {
            window.stream2Player.addClass('vjs-has-started');
        }
    }

    o.pause = function () {
        window.stream2Player.pause();
    }

    o.resetPlayer = function () {
        Stream2Player.pause();
        window.stream2Player.removeClass('vjs-has-started');
        window.stream2Player.currentTime(0);
    }

    o.close = function () {
        $('.close_overlay').trigger('click');
    }

    o.isVideoPlayerVisible = function () {
        return $('#overlay.overlay').hasClass('active') || !$('#overlay.overlay').length;
    }

    o.hideVideoPlayer = function () {
        $('#overlay.overlay').removeClass('active');
    }

    o.showVideoPlayer = function () {
        $('#overlay.overlay').addClass('active');
    }

    o.hideControls = function () {
        window.stream2Player.controls(false);
        $('.video').parent().find('.controls').addClass('controls--hidden');
        $('.video').css({'padding-right': '0'});
    }

    o.showControls = function () {
        window.stream2Player.controls(true);
        $('.video').parent().find('.controls').removeClass('controls--hidden');
        $('.video').css({'padding-right': ''});
    }

    o.showLoading = function () {
        window.stream2Player.addClass('vjs-waiting');
    }

    o.hideLoading = function () {
        window.stream2Player.removeClass('vjs-waiting');
    }

    o.showShowSignUp = function () {

    }

    o.showNoAccess = function (
        isButtonLinkEnabled = true,
        buttonText = null, buttonLink = '#', buttonBackgroundColor = '#66CE93FF', buttonTextColor = '#FFFFFFFF', buttonHoverBackgroundColor = '#66CE93FF', buttonHoverTextColor = '#FFFFFFFF',
        imageSource = null, mobileImageSource = null, imageBackgroundTop = '#FFFFFF00', imageBackgroundBottom = '#FFFFFF00',
        showLoginIfUnauthenticated = false,
        loginButtonText = 'Login', loginButtonBackgroundColor = '#66CE93FF', loginButtonTextColor = '#FFFFFFFF', loginButtonHoverBackgroundColor = '#66CE93FF', loginButtonHoverTextColor = '#FFFFFFFF',
        watchLater = false, watchNowText = 'Watch Now', watchNowButtonHide = false
    ) {
        if($('.stream2-no-access').length) {
            $('.stream2-no-access').remove();
        }
        if(!imageSource) {
            let stream2Params = o.getParams('stream2-plugin.js');
            Stream2Plugin.urls[stream2Params.ep] + '/img/plugin/stream2-placeholder-subscription-desktop.png';
        }
        if(!buttonText) {
            buttonText = 'Buy Now';
        }
        let buttonElement = '';
        if(watchLater !== false) {
            if(watchNowButtonHide === false) {
                buttonElement = "<a class=\"stream2-no-access__button btn-watch-now-modal\" href=\"#\">" + watchNowText + "</a>\n";
            }
        } else {
            buttonElement = "<a class=\"stream2-no-access__button\" href=\"" + buttonLink + "\" target=\"_blank\" rel=\"noopener\">" + buttonText + "</a>\n";
        }
        let loadingComponent = "<div class=\"stream2-no-access\">\n" +
            "<div class=\"stream2-no-access__close\" style=\"display:none;\"><div class=\"stream2-no-access__close-btn\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 320 512\"><path d=\"M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z\"/></svg></div></div>\n" +
            "    <img class=\"stream2-no-access__img stream2-no-access__img--desktop\" src=\"" + imageSource + "\">\n" +
            "    <img class=\"stream2-no-access__img stream2-no-access__img--mobile\" src=\"" + mobileImageSource + "\">\n" +
            buttonElement +
            "    <div class=\"stream2-auth-btn stream2-auth-btn--login stream2-no-access__button\">" + loginButtonText + "</div>\n" +
            "</div>";
        let $loadingComponent = $(loadingComponent);
        if(!showLoginIfUnauthenticated) {
            $loadingComponent.find('.stream2-auth-btn').remove();
        }
        if(imageBackgroundTop || imageBackgroundBottom) {
            let css = 'linear-gradient(' + imageBackgroundTop + ', ' + imageBackgroundBottom + ')';
            $loadingComponent.find('.stream2-no-access__img').css({
                'background': css
            });
        }
        if($('.video-js').parent().find('.controls').length) {
            $loadingComponent.find('.stream2-no-access__close').css({'display':'block'});
        }
        if(window.innerWidth < 576) {
            $loadingComponent.find('.stream2-no-access__img--desktop').addClass('stream2-no-access__img--hidden');
        } else {
            $loadingComponent.find('.stream2-no-access__img--mobile').addClass('stream2-no-access__img--hidden');
        }
        if(Stream2Plugin.isUserLoggedIn()) {
            $loadingComponent.find('.stream2-no-access__button.stream2-auth-btn--login').hide();
        } else {
            $loadingComponent.find('.stream2-no-access__button.stream2-auth-btn--login').show();
        }
        if(!isButtonLinkEnabled) {
            $loadingComponent.find('a.stream2-no-access__button').removeAttr('href').removeAttr('target').removeAttr('rel');
            $loadingComponent.find('a.stream2-no-access__button').css({
                'cursor': 'default'
            });
        }
        o.generateOverlayButtonCss($loadingComponent, isButtonLinkEnabled, buttonBackgroundColor, buttonTextColor, buttonHoverBackgroundColor, buttonHoverTextColor, loginButtonBackgroundColor, loginButtonTextColor, loginButtonHoverBackgroundColor, loginButtonHoverTextColor)
        $(window.stream2Player.el()).closest('.video-js').prepend($loadingComponent);
    }

    o.generateButtonCss = function (selector, backgroundColor, color) {
        return selector + " {background-color:" + backgroundColor + ";color:" + color + ";}";
    }

    o.generateButtonHoverCss = function (selector, backgroundColor, color) {
        return selector + ":hover, " + selector + ":focus {background-color:" + backgroundColor + ";color:" + color + ";}";
    }

    o.generateOverlayButtonCss = function ($loadingComponent, isButtonLinkEnabled, subscribeBackgroundColor, subscribeColor, subscribeHoverBackgroundColor, subscribeHoverColor, loginBackgroundColor, loginColor, loginHoverBackgroundColor, loginHoverColor) {
        let css = o.generateButtonCss('.stream2-no-access a.stream2-no-access__button', subscribeBackgroundColor, subscribeColor) + "\n";
        css += o.generateButtonCss('.stream2-no-access div.stream2-no-access__button', loginBackgroundColor, loginColor) + "\n";
        if(isButtonLinkEnabled) {
            css += o.generateButtonHoverCss('.stream2-no-access a.stream2-no-access__button', subscribeHoverBackgroundColor, subscribeHoverColor) + "\n";
        }
        css += o.generateButtonHoverCss('.stream2-no-access div.stream2-no-access__button', loginHoverBackgroundColor, loginHoverColor);
        let $style = $('<style/>', {
            'html': css
        });
        $loadingComponent.find('style').remove();
        $loadingComponent.append($style);
    }

    o.hideNoAccess = function () {
        $('.stream2-no-access').remove();
    }

    o.updateNoAccessImage = function (url) {
        let $noAccessImage = $('.stream2-no-access__img');
        $noAccessImage.attr('src', url);
    }

    o.updateAccessButton = function (html, link) {
        let $accessButton = $('.stream2-no-access__button');
        $accessButton.html(html);
        $accessButton.attr('href', href);
    }

    o.checkIfUserHasAccess = async function (videoId) {
        Stream2Player.showLoading();
        Stream2Player.hideControls();
        Stream2Player.resetPlayer();
        if(Stream2Player.isVideoPlayerVisible()) {
            axios.post(window.stream2Params.endpoint + '/session/videos/' + videoId, {
                key: window.stream2Params.key,
                profileId: window.stream2Params.profileId,
                sessionId: Cookies.get('S2-SESSION'),
                tempId: Cookies.get('S2-TEMP-SESSION')
            }).then((response) => {

                if(response.data.data.hasOwnProperty('geoProtection'))
                {
                    $(window.stream2Player.el()).closest('.video-js').find('.stream2-geo-protection').remove();
                    $(window.stream2Player.el()).closest('.video-js').prepend(response.data.data.geoProtection);
                    Stream2Player.hideNoAccess();
                    return;
                }

                // If there is supposed to be a countdown timer
                if(response.data.data.hasOwnProperty('isCountDownTimerVisible')
                    && response.data.data.isCountDownTimerVisible) {
                    if(!CountDownTimer.hasCountDownTimer()) {
                        CountDownTimer.append(response.data.data.html, videoId);
                        Stream2Player.hideNoAccess();
                    }
                    return;
                }
                Stream2Plugin.isSubscribed = response.data.data.isSubscribed;
                Stream2Plugin.subscribeButtonLink = response.data.data.subscribeButtonLink;
                Stream2Player.hasAccess = true;
                Stream2Plugin.close($('.stream2-modal'));
                Stream2Plugin.resetModal();
                Stream2Player.hideNoAccess();
                Stream2Player.showControls();
                Stream2Player.play();
            }).catch((error) => {

                if(error.response.data.data.hasOwnProperty('geoProtection'))
                {
                    $(window.stream2Player.el()).closest('.video-js').find('.stream2-geo-protection').remove();
                    $(window.stream2Player.el()).closest('.video-js').prepend(error.response.data.data.geoProtection);
                    Stream2Player.hideNoAccess();
                    return;
                }

                if(error.response.data.data.hasWatchNowLater !== false)
                {
                    Stream2Plugin.generateAndShowWatchNowModal(error.response.data.data.hasWatchNowLater, error.response.data.data.watchNowText);
                }

                Stream2Player.hasAccess = false;
                Stream2Plugin.isSubscribed = error.response.data.data.isSubscribed;
                Stream2Plugin.subscribeButtonLink = error.response.data.data.subscribeButtonLink;
                CountDownTimer.remove();
                Stream2Player.showNoAccess(
                    error.response.data.data.isButtonLinkEnabled,
                    error.response.data.data.buttonText,
                    error.response.data.data.buttonLink,
                    error.response.data.data.buttonBackgroundColor,
                    error.response.data.data.buttonTextColor,
                    error.response.data.data.buttonHoverBackgroundColor,
                    error.response.data.data.buttonHoverTextColor,
                    error.response.data.data.imageSource,
                    error.response.data.data.mobileImageSource,
                    error.response.data.data.imageBackgroundTop,
                    error.response.data.data.imageBackgroundBottom,
                    error.response.data.data.showLoginIfUnauthenticated,
                    error.response.data.data.loginButtonText,
                    error.response.data.data.loginButtonBackgroundColor,
                    error.response.data.data.loginButtonTextColor,
                    error.response.data.data.loginButtonHoverBackgroundColor,
                    error.response.data.data.loginButtonHoverTextColor,
                    error.response.data.data.hasWatchNowLater,
                    error.response.data.data.watchNowButtonText,
                    error.response.data.data.watchNowButtonHide
                );
                Stream2Player.hideControls();
                Stream2Player.pause();
            }).finally(() => {
                if(Stream2Plugin.shouldShowSubscribeButton()) {
                    Stream2Plugin.showSubscribeButton();
                } else {
                    Stream2Plugin.hideSubscribeButton();
                }
                Stream2Player.hideLoading();
            });
        }
    }

    o.eventListeners = function () {
        // When new video is loaded into the player
        if(window.stream2Player) {
            window.onresize = function () {
                if(window.innerWidth < 576) {
                    $('.stream2-no-access__img--desktop').addClass('stream2-no-access__img--hidden');
                    $('.stream2-no-access__img--mobile').removeClass('stream2-no-access__img--hidden');
                } else {
                    $('.stream2-no-access__img--mobile').addClass('stream2-no-access__img--hidden');
                    $('.stream2-no-access__img--desktop').removeClass('stream2-no-access__img--hidden');
                }
            }
            window.stream2Player.on('firstplay', function (e) {
                if(!Stream2Player.hasAccess) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    Stream2Player.resetPlayer();
                }
            });
            window.stream2Player.on('play', function (e) {
                if(!Stream2Player.hasAccess) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    Stream2Player.resetPlayer();
                }
            });
            window.stream2Player.on('error', function (e) {
                Stream2Plugin.brightcoveVideoId = Stream2Player.currentVideoId();
                Stream2Player.checkIfUserHasAccess(Stream2Player.currentVideoId());
            });
            window.stream2Player.on('loadedmetadata', function (e) {
                Stream2Plugin.brightcoveVideoId = Stream2Player.currentVideoId();
                Stream2Player.checkIfUserHasAccess(Stream2Player.currentVideoId());
            });
            window.stream2Player.on('loadeddata', function (e) {
                Stream2Plugin.brightcoveVideoId = Stream2Player.currentVideoId();
                Stream2Player.checkIfUserHasAccess(Stream2Player.currentVideoId());
            });
            window.stream2Player.on('ready', function (e) {
                Stream2Plugin.brightcoveVideoId = Stream2Player.currentVideoId();
                Stream2Player.checkIfUserHasAccess(Stream2Player.currentVideoId());
            });
            $('body').on('click', '.stream2-no-access__close-btn', function () {
                Stream2Player.close();
            });
            $('body').on('click', '.overlay', function (e) {
                if(e.target != this) return;
                Stream2Player.close();
            });
        }
    }

    o.sleep = function(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    o.debugListeners = function () {
        window.stream2Player.on('beforepluginsetup:$name', function (e) {
            console.log('beforepluginsetup:$name');
        });
        window.stream2Player.on('abort', function (e) {
            console.log('abort');
        });
        window.stream2Player.on('beforepluginsetup', function (e) {
            console.log('beforepluginsetup');
        });
        window.stream2Player.on('canplay', function (e) {
            console.log('canplay');
        });
        window.stream2Player.on('canplaythrough', function (e) {
            console.log('canplaythrough');
        });
        window.stream2Player.on('componentresize', function (e) {
            console.log('componentresize');
        });
        window.stream2Player.on('controlsdisabled', function (e) {
            console.log('controlsdisabled');
        });
        window.stream2Player.on('controlsenabled', function (e) {
            console.log('controlsenabled');
        });
        window.stream2Player.on('dispose', function (e) {
            console.log('dispose');
        });
        window.stream2Player.on('durationchange', function (e) {
            console.log('durationchange');
        });
        window.stream2Player.on('emptied', function (e) {
            console.log('emptied');
        });
        window.stream2Player.on('ended', function (e) {
            console.log('ended');
        });
        window.stream2Player.on('enterFullWindow', function (e) {
            console.log('enterFullWindow');
        });
        window.stream2Player.on('enterpictureinpicture', function (e) {
            console.log('enterpictureinpicture');
        });
        window.stream2Player.on('error', function (e) {
            console.log('error');
        });
        window.stream2Player.on('exitFullWindow', function (e) {
            console.log('exitFullWindow');
        });
        window.stream2Player.on('firstplay', function (e) {
            console.log('firstplay');
        });
        window.stream2Player.on('fullscreenchange', function (e) {
            console.log('fullscreenchange');
        });
        window.stream2Player.on('languagechange', function (e) {
            console.log('languagechange');
        });
        window.stream2Player.on('leavepictureinpicture', function (e) {
            console.log('leavepictureinpicture');
        });
        window.stream2Player.on('loadeddata', function (e) {
            console.log('loadeddata');
        });
        window.stream2Player.on('loadedmetadata', function (e) {
            console.log('loadedmetadata');
        });
        window.stream2Player.on('loadstart', function (e) {
            console.log('loadstart');
        });
        window.stream2Player.on('pause', function (e) {
            console.log('pause');
        });
        window.stream2Player.on('play', function (e) {
            console.log('play');
        });
        window.stream2Player.on('playerresize', function (e) {
            console.log('playerresize');
        });
        window.stream2Player.on('playing', function (e) {
            console.log('playing');
        });
        window.stream2Player.on('pluginsetup', function (e) {
            console.log('pluginsetup');
        });
        window.stream2Player.on('posterchange', function (e) {
            console.log('posterchange');
        });
        window.stream2Player.on('progress', function (e) {
            console.log('progress');
        });
        window.stream2Player.on('ratechange', function (e) {
            console.log('ratechange');
        });
        window.stream2Player.on('ready', function (e) {
            console.log('ready');
        });
        window.stream2Player.on('resize', function (e) {
            console.log('resize');
        });
        window.stream2Player.on('seeked', function (e) {
            console.log('seeked');
        });
        window.stream2Player.on('seeked', function (e) {
            console.log('seeked');
        });
        window.stream2Player.on('seeking', function (e) {
            console.log('seeking');
        });
        window.stream2Player.on('sourceset', function (e) {
            console.log('sourceset');
        });
        window.stream2Player.on('stalled', function (e) {
            console.log('stalled');
        });
        window.stream2Player.on('suspend', function (e) {
            console.log('suspend');
        });
        window.stream2Player.on('tap', function (e) {
            console.log('tap');
        });
        window.stream2Player.on('textdata', function (e) {
            console.log('textdata');
        });
        window.stream2Player.on('texttrackchange', function (e) {
            console.log('texttrackchange');
        });
        window.stream2Player.on('timeupdate', function (e) {
            console.log('timeupdate');
        });
        window.stream2Player.on('useractive', function (e) {
            console.log('useractive');
        });
        window.stream2Player.on('userinactive', function (e) {
            console.log('userinactive');
        });
        window.stream2Player.on('usingcustomcontrols', function (e) {
            console.log('usingcustomcontrols');
        });
        window.stream2Player.on('usingnativecontrols', function (e) {
            console.log('usingnativecontrols');
        });
        window.stream2Player.on('volumechange', function (e) {
            console.log('volumechange');
        });
        window.stream2Player.on('waiting', function (e) {
            console.log('waiting');
        });
        window.stream2Player.on('pluginsetup:$name', function (e) {
            console.log('pluginsetup:$name');
        });
    }

})(Stream2Player);

export { Stream2Player }

